import { UUIDUtil } from '@aperza/util';
import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { AcDropdownItem } from './AcDropdownItem';
import { AcDropdownLinkToggle } from './AcDropdownLinkToggle';
import { AcDropdownToggle } from './AcDropdownToggle';
export const AcDropdown = (props) => {
    const { id = `ac_action_dropdown_${UUIDUtil.uuid()}`, title, align = 'left', actions = [], data, functionContext, dropdownClassName, disableDropdownIcon, disabled = false, readOnly, dropdownSize, toggleAs, toggleVariant = 'link', toggleSize, toggleClassName, toggleActive, menuMinWidth = 190, menuMaxHeight = 394, displayOnHover, styles, menuPosition = 'fixed', onMouseDown, children, } = props;
    const [showMenu, setShowMenu] = useState(false);
    let titleNode;
    if (typeof title === 'function') {
        titleNode = title(data || {}, functionContext || {});
    }
    else {
        titleNode = title;
    }
    let toggleClassNameNode;
    if (typeof toggleClassName === 'function') {
        toggleClassNameNode = toggleClassName(data || {}, functionContext || {});
    }
    else {
        toggleClassNameNode = toggleClassName;
    }
    const renderStyle = () => {
        const cssStyles = {};
        return styles || cssStyles;
    };
    return (React.createElement(Dropdown, { alignRight: align === 'right', drop: "down", onMouseEnter: () => displayOnHover && setShowMenu(true), show: !disabled && displayOnHover && showMenu, onMouseLeave: () => displayOnHover && setShowMenu(false), onToggle: (isOpen) => setShowMenu(isOpen), className: dropdownClassName },
        React.createElement(Dropdown.Toggle, { as: toggleAs ?? toggleVariant === 'link' ? AcDropdownLinkToggle : AcDropdownToggle, id: id, toggleClassName: `${toggleClassNameNode}`, variant: toggleVariant, readOnly: readOnly, 
            // `size` props cannot be used as it is not support custom size
            toggleSize: toggleSize, disabled: disabled, active: (!disabled && showMenu) || toggleActive, disableDropdownIcon: disableDropdownIcon },
            React.createElement(React.Fragment, null, titleNode)),
        React.createElement(Dropdown.Menu, { renderOnMount: false, popperConfig: {
                strategy: menuPosition,
                modifiers: [
                    // displayOnHover cannot have offset
                    !displayOnHover
                        ? {
                            name: 'offset',
                            options: {
                                offset: [0, 8],
                            },
                        }
                        : {},
                ],
            }, style: {
                overflowY: 'auto',
                minWidth: menuMinWidth,
                maxHeight: menuMaxHeight,
                ...renderStyle(),
            }, onMouseLeave: () => setShowMenu(false) },
            actions
                .filter((action) => {
                if (typeof action.hide === 'function') {
                    return !action.hide(data || {}, functionContext || {});
                }
                return !action.hide;
            })
                .map((action, index) => (React.createElement(AcDropdownItem, { onMouseDown: onMouseDown, onClickBeforeAction: () => displayOnHover && setShowMenu(false), key: `${index}`, eventKey: `${index}`, data: data, functionContext: functionContext, action: action, size: dropdownSize }))),
            children)));
};
AcDropdown.displayName = 'AcDropdown';
